import type { ApolloClient } from '@apollo/client';
import {
  ResidenceApartmentsDocument,
  type ResidenceApartmentsQuery
} from '../../graphql/graphql';

const APARTMENTS_PAGE_SIZE = 50;

export type ResidenceApartment = NonNullable<
  NonNullable<
    NonNullable<ResidenceApartmentsQuery['residence']>['apartments']['nodes']
  >[number]
>;

const fetchResidenceApartmentsPage = async (
  apolloClient: ApolloClient<object>,
  slug: string,
  after?: string | null
): Promise<ResidenceApartment[]> => {
  const { data } = await apolloClient.query({
    query: ResidenceApartmentsDocument,
    fetchPolicy: 'no-cache',
    variables: {
      slug,
      first: APARTMENTS_PAGE_SIZE,
      after
    }
  });

  const connection = data?.residence?.apartments;
  if (!connection) {
    return [];
  }

  const apartments = (connection.nodes ?? []).filter(
    (node): node is ResidenceApartment => !!node
  );

  if (!connection.pageInfo?.hasNextPage) {
    return apartments;
  }

  const nextCursor = connection.pageInfo.endCursor;
  if (!nextCursor) {
    return apartments;
  }

  const nextApartments = await fetchResidenceApartmentsPage(
    apolloClient,
    slug,
    nextCursor
  );

  return apartments.concat(nextApartments);
};

export const fetchRemainingResidenceApartments = (
  apolloClient: ApolloClient<object>,
  slug: string,
  after: string
): Promise<ResidenceApartment[]> =>
  fetchResidenceApartmentsPage(apolloClient, slug, after);
